<template>
  <div class="ProjectLayout" data-locator="project-settings-page">
    <ProjectSettingsMainSettings :mnemo="roomMnemo"/>
    <ProjectSettingsAccessRights class="mt-8" :mnemo="roomMnemo"/>
    <ProjectSettingsFeatures v-if="allowValidationChecklistItemDeletion" class="mt-8" :mnemo="roomMnemo"/>
    <ProjectSettingsInformation class="mt-8" :mnemo="roomMnemo"/>
    <ProjectSettingsSignatures class="mt-8" :mnemo="roomMnemo"/>
    <ProjectSettingsNotifications class="mt-8" :mnemo="roomMnemo"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ProjectSettingsNotifications from '@/project/project-settings/notifications/ProjectSettingsNotifications.vue'

import ProjectSettingsAccessRights from '../access-rights/AccessRights.vue'
import ProjectSettingsFeatures from '../ProjectSettingsFeatures.vue'
import ProjectSettingsInformation from '../ProjectSettingsInformation.vue'
import ProjectSettingsMainSettings from '../ProjectSettingsMainSettings.vue'
import ProjectSettingsSignatures from '../signatures/ProjectSettingsSignatures.vue'

export default {
  name: 'ProjectLayout',
  components: {
    ProjectSettingsAccessRights,
    ProjectSettingsFeatures,
    ProjectSettingsInformation,
    ProjectSettingsMainSettings,
    ProjectSettingsNotifications,
    ProjectSettingsSignatures,
  },
  computed: {
    ...mapGetters('room', ['allowValidationChecklistItemDeletion', 'roomMnemo']),
  },
}
</script>
